import { render, staticRenderFns } from "./VPrescriptionDrawingUploadForm.vue?vue&type=template&id=70ff6f5c&"
import script from "./VPrescriptionDrawingUploadForm.vue?vue&type=script&lang=ts&"
export * from "./VPrescriptionDrawingUploadForm.vue?vue&type=script&lang=ts&"
import style0 from "./VPrescriptionDrawingUploadForm.vue?vue&type=style&index=0&id=70ff6f5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports